import { makeStyles } from "tss-react/mui";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Preview_styles_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Preview_styles_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const useStyles = makeStyles()(({ breakpoints, tokens, px }, params, classes)=>{
    var _params_width, _params_height;
    return {
        root: {
            position: 'relative'
        },
        square: {
            paddingTop: '100%'
        },
        document: {
            width: '100%',
            canvas: {
                border: 'none'
            },
            borderRadius: tokens.radius.l,
            overflow: 'hidden',
            transform: 'translate3d(0,0,0)'
        },
        document_square: {
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            overflow: 'hidden'
        },
        image: _object_spread({
            width: null != (_params_width = params.width) ? _params_width : params.height || params.maxHeight ? 'auto' : '100%',
            height: null != (_params_height = params.height) ? _params_height : 'auto'
        }, params.maxHeight && {
            maxHeight: params.maxHeight
        }, params.maxWidth && {
            maxWidth: params.maxWidth
        }, params.width && params.height && {
            objectFit: 'contain'
        }),
        image_square: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        },
        centerImage: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        previewDocx: {
            minHeight: px(80),
            height: '100%'
        },
        docImage: {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: px(36),
            height: px(36),
            [breakpoints.up('sm')]: {
                width: tokens.spacing['56'],
                height: tokens.spacing['56']
            }
        },
        hiddenPage: {
            display: 'none'
        },
        pagination: {
            position: 'absolute',
            top: tokens.spacing['12'],
            left: tokens.spacing['12'],
            display: 'flex',
            alignItems: 'center',
            gap: tokens.spacing['12'],
            [breakpoints.up('md')]: {
                right: tokens.spacing['12'],
                left: 'auto'
            }
        },
        collapseBox: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            borderTop: `${tokens.border.s}px solid ${tokens.colors.stroke.primary}`,
            padding: `${tokens.spacing['4']}px ${tokens.spacing['16']}px`,
            background: tokens.colors.bg.light.primary,
            transform: 'translateY(100%)',
            transition: 'transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            display: 'flex',
            justifyContent: 'flex-end'
        },
        downloadButton: {
            display: 'flex',
            gap: tokens.spacing['4'],
            alignItems: 'center',
            cursor: 'pointer'
        },
        mobileCollapseBox: {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
        },
        collapseWrapper: _object_spread_props(_object_spread({
            position: 'relative'
        }, params.height && {
            height: params.height
        }, params.width && {
            width: params.width
        }, params.maxHeight && {
            maxHeight: params.maxHeight
        }, params.maxWidth && {
            maxWidth: params.maxWidth
        }), {
            [`&:hover .${classes.collapseBox}`]: {
                transform: 'translate(0)'
            }
        }),
        previewButtons: {
            '& .MuiButton-sizeLarge': {
                width: '72px !important'
            }
        },
        expandButton: {
            position: 'absolute',
            top: tokens.spacing['12'],
            right: tokens.spacing['12']
        }
    };
});
export { useStyles };
